/* Count-up stats when band scrolls into view; respects prefers-reduced-motion */
(() => {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  const easeOutCubic = (t) => 1 - (1 - t) ** 3;

  const formatVal = (n, decimals) => {
    const d = Math.min(4, Math.max(0, Number.parseInt(String(decimals), 10) || 0));
    if (d === 0) return String(Math.round(n));
    return n.toFixed(d);
  };

  const applyFinal = (el) => {
    const target = Number.parseFloat(el.getAttribute("data-target") || "0");
    const suffix = el.getAttribute("data-suffix") || "";
    const prefix = el.getAttribute("data-prefix") || "";
    const decimals = el.getAttribute("data-decimals") || "0";
    el.textContent = `${prefix}${formatVal(Number.isFinite(target) ? target : 0, decimals)}${suffix}`;
    el.setAttribute("data-tt-stat-done", "true");
  };

  const animateEl = (el) => {
    if (el.getAttribute("data-tt-stat-done") === "true") return;
    const target = Number.parseFloat(el.getAttribute("data-target") || "0");
    const suffix = el.getAttribute("data-suffix") || "";
    const prefix = el.getAttribute("data-prefix") || "";
    const decimals = el.getAttribute("data-decimals") || "0";
    const safeTarget = Number.isFinite(target) ? target : 0;

    if (reduced.matches || safeTarget === 0) {
      applyFinal(el);
      return;
    }

    const start = performance.now();
    const duration = 1200;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = easeOutCubic(t);
      const current = safeTarget * eased;
      el.textContent = `${prefix}${formatVal(current, decimals)}${suffix}`;
      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        el.setAttribute("data-tt-stat-done", "true");
      }
    };
    requestAnimationFrame(tick);
  };

  const initBand = (band) => {
    const stats = [...band.querySelectorAll("[data-tt-stat]")];
    if (!stats.length) return;
    if (band.getAttribute("data-tt-stats-observing") === "true") return;

    if (reduced.matches || (window.Shopify && Shopify.designMode)) {
      stats.forEach(applyFinal);
      return;
    }

    band.setAttribute("data-tt-stats-observing", "true");
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          stats.forEach((el, i) => {
            window.setTimeout(() => animateEl(el), i * 90);
          });
          obs.disconnect();
          band.removeAttribute("data-tt-stats-observing");
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(band);
  };

  const scan = () => {
    document.querySelectorAll("[data-tt-stats-band]").forEach(initBand);
  };

  scan();
  document.addEventListener("shopify:section:load", (e) => {
    const sid = e.detail && e.detail.sectionId;
    const root =
      (sid && document.getElementById(`shopify-section-${sid}`)) ||
      (e.target && e.target.nodeType === 1 ? e.target : null);
    if (!root || !root.querySelector || !root.querySelector("[data-tt-stats-band]")) return;
    root.querySelectorAll("[data-tt-stats-band]").forEach((band) => {
      band.removeAttribute("data-tt-stats-observing");
      band.querySelectorAll("[data-tt-stat]").forEach((el) => el.removeAttribute("data-tt-stat-done"));
      initBand(band);
    });
  });
})();
